import { Box, Skeleton } from '@mui/material'

export const Loader = () => {
    return (
        <Box display="flex" flexDirection="column" gap="16px" width="100%">
            <Box display="flex" alignItems="flex-start" gap="8px" width="100%">
                <Skeleton variant="circular" width={37} height={35} sx={{bgcolor:"#EAEEF5"}} />
                <Skeleton variant="rectangular" width="80%" height={60} sx={{bgcolor:"#EAEEF5", borderRadius: '0px 40px 40px 40px'}}/>
            </Box>
        </Box>  
    )
}
